<div class="coupon-code-wrapper" [ngClass]="{'detailed': isDetailedLayout}">
  <!-- Collapsed State: Show "Add promo code" link -->
  <div class="apply-promo-code-wrapper" *ngIf="isCollapsed" (click)="toggleExpand()">
    <ng-icon [name]="'heroTagSolid'" [size]="'13px'" [color]="'#9487A0'"></ng-icon>
    <div class="ml-sm pointer">
      Add promo code
    </div>
  </div>

  <!-- Expanded State: Show input with Apply button inside -->
  <div class="coupon-input-wrapper" *ngIf="isExpanded">
    <div class="input-with-button">
      <rosie-text [control]="activeControl" [placeholderTranslationKey]="'Add promotion code...'"
        (keyup.enter)="applyCoupon()" [customClass]="isDefaultLayout ? 'narrow' : ''">
      </rosie-text>
      <button type="button" class="apply-button-inside" (click)="applyCoupon()" [disabled]="inProgress">
        {{ inProgress ? 'Applying...' : 'Apply' }}
      </button>
    </div>
    <rosie-validation-error [show]="activeControl.errors?.required && activeControl.touched"
      [translationKey]="'COMMON.VALIDATION.REQUIRED'" [translationAttributes]="{value: 'Promotion code'}">
    </rosie-validation-error>
    <div class="error-message" *ngIf="errorMessage && !activeControl.errors?.required">{{ errorMessage }}</div>
  </div>
  <ng-container *ngIf="isAdded && isDetailedLayout">
    <div class="coupon-added-detailed-wrapper">
      <div class="coupon-added-detailed">
        <ng-icon [name]="'heroTagSolid'" [size]="'13px'" [color]="'#9332E0'"></ng-icon>
        {{ appliedCouponName }}
        <ng-icon [name]="'heroXMark'" [size]="'13px'" [color]="'#9332E0'" class="coupon-remove-icon"
          (click)="removeCoupon()"></ng-icon>
      </div>
      <span class="coupon-description" *ngIf="couponDescription">{{ couponDescription }}</span>
    </div>

  </ng-container>
  <ng-container *ngIf="isAdded && isDefaultLayout">
    <div class="coupon-added-default-wrapper">
      <div class="coupon-added-default">
        <ng-icon [name]="'heroTagSolid'" [size]="'13px'" [color]="'#9487A0'"></ng-icon>
        {{ appliedCouponName }}
      </div>
      <div class="coupon-remove-action" (click)="removeCoupon()">
        <ng-icon [name]="'heroXMark'" [size]="'13px'" [color]="'#7F728A'"></ng-icon>
        REMOVE
      </div>
    </div>
  </ng-container>
</div>